// @ts-nocheck

import dom2 from "jsx-render";

// The reason for wrapping `jsx-render`'s `dom()` function is that it fails on a check
// to `element.prototype.render` (function composeToFunction) because `element.prototype`
// is `undefined`.
//
// TODO: upgrade `jsx-render` dependency and remove this file.

function dom(element, attrs, ...children) {
	if (typeof element === "function" && element.prototype === undefined)
		element.prototype = {};

	// Gotta use ".default" because of CommonJS vs ESM nonsense. Kill me now.
	const dom3 = dom2.default ?? dom2;
	return dom3(element, attrs, ...children);
}

export default dom;
